import React from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius, calculateRemSize, flex, p, w100} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    creatorImageSrc?: string;
    creatorName?: string;
    title?: string;
}

export const ReelDetailsHeader = (props: IProps) => {
    return (
        <div css={wrapperStyle}>
            {props.creatorImageSrc && (
                <div css={logoWrapper}>
                    <Image src={props.creatorImageSrc} alt="" width="auto" height="auto" imageStyle={imageStyle} css={logoStyle} />
                </div>
            )}
            <div css={[w100]}>
                {props.creatorName && (
                    <Text variant="info_txt_2" mb={0.5} css={textGeneralStyle}>
                        {props.creatorName}
                    </Text>
                )}

                {props.title && (
                    <Text variant="body_copy_2" css={textGeneralStyle}>
                        {props.title}
                    </Text>
                )}
            </div>
        </div>
    );
};

const wrapperStyle = css`
    ${p(0, 2)};
    ${flex("flex-start", "space-between")};
    gap: ${calculateRemSize(1)};
    user-select: none;
`;

const logoWrapper = (theme: Theme) => css`
    flex: 0 0 auto;
    position: relative;
    width: ${calculateRemSize(6)};
    height: ${calculateRemSize(6)};
    ${borderRadius(3)};
    overflow: hidden;
    border: 2px solid ${theme.colors.gray[400]};
    background: #fff;
`;

const logoStyle = css`
    width: 100%;
    height: 100%;
`;

const textGeneralStyle = css`
    color: #fff;
    text-shadow: 0 1px 1px #000;
`;

// CSS properties:
const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover" as const
};
import React from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius, calculateRemSize, flex, p, w100} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    creatorImageSrc?: string;
    creatorName?: string;
    title?: string;
}

export const ReelDetailsHeader = (props: IProps) => {
    return (
        <div css={wrapperStyle}>
            {props.creatorImageSrc && (
                <div css={logoWrapper}>
                    <Image src={props.creatorImageSrc} alt="" width="auto" height="auto" imageStyle={imageStyle} css={logoStyle} />
                </div>
            )}
            <div css={[w100]}>
                {props.creatorName && (
                    <Text variant="info_txt_2" mb={0.5} css={textGeneralStyle}>
                        {props.creatorName}
                    </Text>
                )}

                {props.title && (
                    <Text variant="body_copy_2" css={textGeneralStyle}>
                        {props.title}
                    </Text>
                )}
            </div>
        </div>
    );
};

const wrapperStyle = css`
    ${p(0, 2)};
    ${flex("flex-start", "space-between")};
    gap: ${calculateRemSize(1)};
    user-select: none;
`;

const logoWrapper = (theme: Theme) => css`
    flex: 0 0 auto;
    position: relative;
    width: ${calculateRemSize(6)};
    height: ${calculateRemSize(6)};
    ${borderRadius(3)};
    overflow: hidden;
    border: 2px solid ${theme.colors.gray[400]};
    background: #fff;
`;

const logoStyle = css`
    width: 100%;
    height: 100%;
`;

const textGeneralStyle = css`
    color: #fff;
    text-shadow: 0 1px 1px #000;
`;

// CSS properties:
const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover" as const
};
